module.exports = __webpack_public_path__ + "static/img/bgImage3.1703046.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/productCenter/subnav3/tab1/wap/bgImage3.jpg
// module id = +dn4
// module chunks = 0